import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { format } from 'date-fns';
import Section from '../../section';
import Container from '../../container';
import AccountDetailGrid from '../account-detail-grid';
import Table from '../../table';

const dateStyle = `
  color: #757575;
`;

const titleStyle = `
  margin: 0;
  font-size: ${rem(20)};
`;

const formatFundraisers = data => data.map(d => ({
  id: d.id,
  data: [
    {
      content: d.title,
      styles: titleStyle,
    },
    {
      content: d.dateCreated && format(d.dateCreated, 'MM/DD/YYYY'),
      styles: dateStyle,
    },
    {
      content: d.fundsRaised.formatted || '$0',
    },
    {
      content: 'View',
      ...(d.slug ? { link: `/${d.type === 3 ? 'fundraisers' : 'couriers'}/${d.slug}` } : {}),
    },
  ],
}));

const PublicAccountDetails = ({ user, userId }) => (
  <Section dark>
    <Container>

      {user.totals && user.totals.couriers > 0 &&
        <AccountDetailGrid headline="Courier Programs">
          <Table
            dataEndpoint={`v1/users/${userId}/couriers`}
            dataFormat={formatFundraisers}
            dataParams={{ limit: 5 }}
          />
        </AccountDetailGrid>
      }

      {user.totals && user.totals.fundraisers > 0 &&
        <AccountDetailGrid headline="Fundraisers">
          <Table
            dataEndpoint={`v1/users/${userId}/fundraisers`}
            dataFormat={formatFundraisers}
            dataParams={{ limit: 5 }}
          />
        </AccountDetailGrid>
      }

    </Container>
  </Section>
);

PublicAccountDetails.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.string,
};

export default PublicAccountDetails;

